import React from 'react'

export default function labelBlock(label, size, style) {
  return label === undefined ? null : (
    <div className={`label ${size}`} style={{...style}}>
      <label className="label">{label}</label>
    </div>
  );
}